import { useQuery } from '@tanstack/react-query'

import type { MissionStoreStatusParams } from '@/api/model/missionType'
import { getMissionCalendarApi, getMissionDetailApi, getMissionListApi } from '@/api/missionApi'

export const useMissionListQuery = (params: MissionStoreStatusParams) => {
  return useQuery({
    queryKey: ['missionList', params],
    queryFn: () => getMissionListApi(params)
  })
}

export const useMissionDetailQuery = (id: string) => {
  return useQuery({
    queryKey: ['missionDetail', id],
    queryFn: () => getMissionDetailApi(id)
  })
}

export const useMissionCalendarQuery = (id: string, date: string) => {
  return useQuery({
    queryKey: ['missionCalendar', id, date],
    queryFn: () => getMissionCalendarApi(id, date)
  })
}
